import { render, staticRenderFns } from "./nvDate.vue?vue&type=template&id=2dd8c345"
import script from "./nvDate.vue?vue&type=script&lang=js"
export * from "./nvDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports